import { isAxiosError } from 'axios';
/**
 * Message à montrer pour une erreur d'appel à l'API : celui du serveur (`error`,
 * ou `errors` par champ pour la validation), sinon un message selon la cause.
 */
export function apiErrorMessage(err, fallback = "L'opération a échoué. Réessayez.") {
    if (!isAxiosError(err))
        return fallback;
    if (!err.response)
        return 'Impossible de joindre le serveur. Vérifiez votre connexion.';
    const data = err.response.data;
    if (data && typeof data === 'object') {
        if (typeof data.error === 'string' && data.error)
            return data.error;
        if (data.errors && typeof data.errors === 'object') {
            const fields = Object.values(data.errors).filter((v) => typeof v === 'string');
            if (fields.length)
                return fields.join(' ');
        }
    }
    const status = err.response.status;
    if (status === 403)
        return "Vous n'avez pas les droits pour cette action.";
    if (status === 404)
        return "L'élément n'existe plus. Rechargez la page.";
    if (status >= 500)
        return 'Erreur du serveur. Réessayez dans quelques instants.';
    return fallback;
}
